module.exports = __webpack_public_path__ + "static/media/play.d9e60e15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.svg
// module id = 44
// module chunks = 0